import { render, staticRenderFns } from "./PartnerRestriction.vue?vue&type=template&id=0f309c89&scoped=true"
import script from "./PartnerRestriction.vue?vue&type=script&lang=ts"
export * from "./PartnerRestriction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f309c89",
  null
  
)

export default component.exports